import type { ElementType } from 'react';

import { ROLE_LEBT_ADMIN } from '~/consts/roles';

import ActivityTab from './Tabs/ActivityTab';
import BusinessSettingTab from './Tabs/BusinessSettingTab';
import BusinessTab from './Tabs/BusinessTab';
import EmployeesTab from './Tabs/EmployeesTab';
import FrequentFlyerTab from './Tabs/FrequentFlyerTab';
import NdcFlightsTab from './Tabs/NdcFlightsTab';
import OrderTab from './Tabs/OrdersTab';
import ServiceFeeTab from './Tabs/ServiceFeeTab';

interface TabConfig {
  component: ElementType;
  label: string;
  requiredRoles?: Array<string>;
}

export const tabsMap: Record<string, TabConfig> = {
  business: {
    requiredRoles: [ROLE_LEBT_ADMIN],
    component: BusinessTab,
    label: 'Business',
  },
  serviceFee: {
    requiredRoles: [ROLE_LEBT_ADMIN],
    component: ServiceFeeTab,
    label: 'Service Fees',
  },
  employees: {
    component: EmployeesTab,
    label: 'Employees',
  },
  frequentFlyer: {
    requiredRoles: [ROLE_LEBT_ADMIN],
    component: FrequentFlyerTab,
    label: 'Corporate airline programs',
  },
  orders: {
    component: OrderTab,
    label: 'Orders',
  },
  activity: {
    component: ActivityTab,
    label: 'Activity Log',
  },
  ndcFlights: {
    component: NdcFlightsTab,
    label: 'NDC Flights',
  },
  businessSetting: {
    component: BusinessSettingTab,
    label: 'Business Setting',
  },
};
